import { render, staticRenderFns } from "./ViewPurchasesDeliveryPage.vue?vue&type=template&id=4c62ff80"
import script from "./ViewPurchasesDeliveryPage.vue?vue&type=script&lang=js"
export * from "./ViewPurchasesDeliveryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports